import React, { useContext, useEffect } from "react";
import { httpGetUnsecure, serverGET } from "Utils/HttpFunctions";
import { useLocation, useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { authContext } from "context/Auth";
import loggingInDev from "loggingInDev";
import { integrationContext } from "context/Integrations";
import { LoginLoader } from "components/LoginLoader";

export default function OutlookIntegration() {
  const navigate = useNavigate();
  const { isLogged } = useContext(authContext);
  const { getUser } = useContext(integrationContext);
  const location = useLocation();

  useEffect(() => {
    connectCalendar();
  }, [isLogged]);

  const connectCalendar = async () => {
    if (isLogged === true) {
      loggingInDev("window location ==>", window.location);
      const path = `/outlook/integration${window.location.search}`;
      const response = await serverGET(path);
      if (response && response.constructor !== String) {
        loggingInDev("response inside component ===>", response);
        const data = response.data.user;
        loggingInDev("data", data);
        console.log("data ===> ", data);
        await getUser();
        navigate("/dashboard", { replace: true });
      }
    }
  };

  return (
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
      }}
    >
      <LoginLoader />
    </div>
  );
}
